import React, { useEffect, useRef } from 'react';
import { AudioPlayerState, useAudioPlayer } from './useAudioPlayer';

export type AudioPlayerProps = {
    stream: MediaStream | null;
    paused: boolean;
    onStateUpdate: (newState: AudioPlayerState) => void;
}

export const AudioPlayer = (props: AudioPlayerProps) => {
    const { stream, paused, onStateUpdate } = props;

    const audioRef = useRef<HTMLAudioElement>(null);

    const { state } = useAudioPlayer(audioRef, stream, paused);

    useEffect(() => {
        onStateUpdate(state);
    }, [onStateUpdate, state]);

    return (
        <audio ref={audioRef} muted />
    );
};
